import { Note1 } from 'iconsax-react'
import { IconButton, useTheme } from '@mui/material'

import Tooltip from '../Tooltip'

import { useNoteVisibility } from '@SonarCX/providers/NoteVisibilityProvider'
import useStyles from './styles'

const TopBarNote = () => {
  const { toggle: toggleModal } = useNoteVisibility()
  const theme = useTheme()
  const classes = useStyles()

  return (
    <Tooltip arrow title='My notes'>
      <IconButton className={classes.root} onClick={toggleModal}>
        <Note1 size={theme.size.lg} color='black' />
      </IconButton>
    </Tooltip>
  )
}

export default TopBarNote
